/**
 * Detailed Summary page heading. The heading names the VIEW only ("Detailed
 * Summary") — the active dashboard ("KFE - WBR") is established once by the
 * header switcher, so repeating it here would be redundant chrome (decided
 * 2026-08-21). No network scope either: scoping lives entirely in the
 * demand-category checkbox row (spec detail-summary-scoping R1.2).
 */

import React from 'react';
import Header from '@amzn/awsui-components-core/header';

export const PageHeader: React.FC = () => (
  <Header variant="h1">Detailed View</Header>
);
